import { Component, OnInit } from '@angular/core';
import { NativeService } from './../providers/NativeService';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpService } from "./../providers/HttpService"
import { Utils } from "./../providers/Utils";

@Component({
  selector: 'app-set-meal-list',
  templateUrl: './set-meal-list.component.html',
  styleUrls: ['./set-meal-list.component.css']
})
export class SetMealListComponent implements OnInit {
  public allSever: string = 'downon'; // downoff downon upoff upon
  public priceStatus: string = '0'; // 1 从低到高 2 从高到低
  public screenType: any = 0; // 0全部 1价格 2销量
  public infoList: Array<any> = [];
  public infoPage: number = 1;
  public infoStatus: boolean = true;
  public showScreenBtn: boolean = false;
  public typeList: Array<any> = [];
  public typeIndex: number | String = 0;
  public searchVal: any = '';
  public typeNum: number = 2;//1 块状 2条状

  constructor(
    public nativeService: NativeService,
    public utils: Utils,
    public http: HttpService,
    public routeInfo: ActivatedRoute,
    public router: Router
  ) { }

  ngOnInit() {
    this.routeInfo.queryParams.subscribe(query => {
      this.typeIndex = query.categoryid ? query.categoryid : 0;
    })
    // 获取列表
    this.getList();
    // 获取类别
    this.getTypeList();
  }
  // 返回
  public backToPage() {
    this.nativeService.backToPage();
  }
  // 点击全部商品
  public changeType() {
    if (this.screenType != 0) {
      this.allSever = 'upon';
    } else {
      this.allSever = this.allSever == 'downon' ? 'upon' : 'downon';
    }
    this.screenType = 0;
    this.priceStatus = '0'; // 1 从低到高 2 从高到低
    this.showScreenBtn = !this.showScreenBtn;
  }
  // 点击价格
  public changePrice() {
    if (this.screenType != 2) {
      this.priceStatus = '1';
    } else {
      this.priceStatus = this.priceStatus == '1' ? '2' : '1';
    }
    this.screenType = 2;
    this.allSever = 'downoff';
    this.showScreenBtn = false;
    this.typeIndex = 0;
    // 更新列表
    this.toSearch();
  }
  // 点击综合
  public changeZH() {
    this.screenType = 1;
    this.allSever = 'downoff'; // downoff downon upoff upon
    this.priceStatus = '0'; // 1 从低到高 2 从高到低
    this.showScreenBtn = false;
    this.typeIndex = 0;
    // 更新列表
    this.toSearch();
  }
  // 点击距离
  public changeSales() {
    this.screenType = 3;
    this.allSever = 'downoff'; // downoff downon upoff upon
    this.priceStatus = '0'; // 1 从低到高 2 从高到低
    this.showScreenBtn = false;
    this.typeIndex = 0;
    // 更新列表
    this.toSearch();
  }
  // 隐藏
  public closeScreenBtn() {
    this.allSever = 'downon';
    this.showScreenBtn = false;
  }
  // 修改类别
  public changeTypeIndex(index) {
    this.typeIndex = index;
    // 更新列表
    this.toSearch();
    // 隐藏
    this.closeScreenBtn();
  }
  // 商品详情
  public goDetail(sid) {
    this.router.navigate(['serveSetMealDetail'], { queryParams: { type: 'package', id: sid } });
  }
  // 获取列表
  public getList() {
    let params = {
      'openalias': 'wap.saas.setmealprogram.setmealList',
      'plat': 'plat_wap',
      'openno': '2',
      'syscategoryid': this.typeIndex,
      'lng': this.utils.getLocalStorageItem('lng'),
      'lat': this.utils.getLocalStorageItem('lat'),
      'page': this.infoPage,
      'limit': '10',
      'order': (this.screenType == 1 || this.screenType == 2) ? this.priceStatus : this.screenType,
      'keyword': this.searchVal
    }
    var that = this;
    this.http.request({
      'method': 'GET',
      'url': 'api/index',
      'data': params
    }).then(result => {
      if (result.code == 100) {
        let newArr = result.data.list;
        let oldArr = that.infoList;
        if (newArr && newArr.length > 0) {
          if (that.infoPage == 1) {
            that.infoStatus = true;
            that.infoList = newArr;
          } else {
            that.infoStatus = true;
            that.infoList = oldArr.concat(newArr);
          }
        } else {
          that.infoStatus = false;
        }
      } else {
        this.nativeService.showErrorAlert(result.msg);
      }
    })
  }
  // 获取类别
  public getTypeList() {
    let params = {
      'openalias': 'wap.saas.category.lists',
      'plat': 'plat_wap',
      'openno': '1',
      'type': '2', //1 服务分类,2 套餐分类
    }
    var that = this;
    this.http.request({
      'method': 'GET',
      'url': 'api/index',
      'data': params
    }).then(result => {
      if (result.code == 100) {
        this.typeList = result.data.list;
      } else {
        this.nativeService.showErrorAlert(result.msg);
      }
    })
  }
  // 更新列表
  public toSearch() {
    this.infoList = [];
    this.infoPage = 1;
    this.infoStatus = true;
    // 获取列表
    this.getList();
  }
  // 列表上啦加载更多
  public listMore() {
    if (this.infoStatus) {
      this.infoPage += 1;
      this.getList();
    }
  }
  // 点击搜索
  public gotoSearch() {
    this.toSearch();
  }

  // 切换格式
  public changeTypeNum() {
    this.typeNum = (this.typeNum == 1) ? 2 : 1;
    // 更新列表
    this.toSearch();
  }
}
